import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, Icon }          from "semantic-ui-react";
import UpdateCorporation         from "../../../../application/usecase/corporation/UpdateCorporation";
import Corporation               from "../../../../domain/corporation/Corporation";

const CorporationUpdateButton: FC = () => {
  const corporation: Corporation = useStore().getState().corporation;
  const updateCorporation: UpdateCorporation = new UpdateCorporation(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateCorporation.execute(corporation) }
      >
        <Icon name="save"/>保存する
      </Button>
    </>
  )
};

export default CorporationUpdateButton;
